import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Helmet } from 'react-helmet';
import { Redirect } from 'react-router';
import qs from 'qs';
import BookingDetails from './BookingDetails';
import BookingConfirmation from './BookingConfirmation';
import BookingVehicleSelection from './BookingVehicleSelection';
import BookingMenu from './BookingMenu';
import HiddenForm from './HiddenForm';
import ErrorDisplay from '../utility/ErrorDisplay';
import LottieLoader from '../utility/LottieLoader';
import { withTranslation } from 'react-i18next';
import Cookies from 'js-cookie';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router';

import {
  setBookingAvailDates,
  setBookingDate,
  setBookingPax,
  setBookingPrice,
  setBookingVehicle,
  setMeetingPoint,
  setBookingStep,
  setBookingPrimaryDriver,
  setBookingFormData,
  fetchBookingInfo,
  fetchPricingInfo,
  clearBookingFormData,
  clearPaymentData,
  toggleProceedToPayment,
  fetchSavedInfo,
  postSaveForLater,
  updateSaveForLater,
  setDateWasReset
} from '../../actions/booking';

import { clearApiError, receiveErrorResponse } from '../../actions/api';

import { calcSimplePrice, int } from '../../js/utility';

import { SITE_TITLE } from '../../constants';

class Booking extends Component {
  constructor(props) {
    super(props);
    this.state = {
      initData: false,
      showMobMenu: false,
      promoCode: '',
      insufficientPax: false
    };
    this.initData = this.initData.bind(this);
    this.handleCodeChange = this.handleCodeChange.bind(this);
    this.getPrice = this.getPrice.bind(this);
    this.submitSaveForm = this.submitSaveForm.bind(this);
    this.onPaxChange = this.onPaxChange.bind(this);
  }

  componentDidMount() {
    this._isMounted = true;
    const {
      clearApiError,
      clearPaymentData,
      clearBookingFormData,
      toggleProceedToPayment,
      location,
      submitSaveForm,
      match
    } = this.props;
    clearApiError();
    toggleProceedToPayment(false);
    clearPaymentData();
    clearBookingFormData();
    this.initData();
    //Prefill promo code if exists
    const queryObj = qs.parse(location.search, { ignoreQueryPrefix: true });
    if (queryObj.promo) {
      this.setState({
        promoCode: queryObj.promo
      });
    }

    // if (match.params.slug === 'ford-ranger-training-experience-sabah' || match.params.slug === 'ford-ranger-training-experience'){
    //   if (this.state.promoCode === ''){
    //     this.setState({
    //       promoCode: 'LAUNCH50'
    //     });
    //   }
    // }
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  componentDidUpdate(prevProps) {
    if (this.props.bookingStep !== prevProps.bookingStep) {
      window.scrollTo(0, 0);
    }
    //Ensure minimum pax selected is 2 if a driver is selected
    // const { primaryDriver, bookingPax, setBookingPax } = this.props;
    // if(!primaryDriver && bookingPax < 2) {
    //     setBookingPax(2);
    // }
  }

  //Submits form for 'save for later' and booking submission
  async submitSaveForm(step) {
    const {
      bookingInfo,
      bookingFormData,
      bookingPax,
      bookingDate,
      bookingVehicleId,
      bookingMeetingPointId,
      primaryDriver,
      postSaveForLater,
      updateSaveForLater,
      saveUuid
    } = this.props;

    const { slug, uuid } = this.props.match.params;

    const mobPrefix = '+60';
    let formData = {
      step_no: step,
      tour_date: bookingDate,
      selected_vehicle_id: int(bookingVehicleId),
      meeting_point_id: int(bookingMeetingPointId),
      slug: slug,
      is_own_vehicle: bookingInfo.is_own_vehicle,
      data: {
        personal: {
          full_name: bookingFormData.name,
          ic_no: bookingFormData.ic,
          email: bookingFormData.email,
          mobile_no: mobPrefix.concat(bookingFormData.mobile),
          is_driver: primaryDriver,
          tshirt_size: bookingFormData.size
        },
        booking: {
          pax_no: bookingInfo.isByAge
            ?
            {
              adult: int(bookingPax.adult),
              child: int(bookingPax.child)
            }
            : int(bookingPax)
        }
      }
    };
    if (!primaryDriver) {
      formData.data.driver = {
        full_name: bookingFormData.driver_name,
        ic_no: bookingFormData.driver_ic,
        mobile_no: mobPrefix.concat(bookingFormData.driver_mobile),
        email: bookingFormData.driver_email,
        tshirt_size: bookingFormData.driver_size
      };
    }

    window.scrollTo(0, 0);
    // Check uuid from url and savedUuid received from save for later response
    const submitUuid = uuid || saveUuid;
    if (submitUuid === '') {
      await postSaveForLater(
        formData,
        decodeURIComponent(Cookies.get('XSRF-TOKEN'))
      );
    } else {
      await updateSaveForLater(
        formData,
        decodeURIComponent(Cookies.get('XSRF-TOKEN')),
        submitUuid
      );
    }
  }

  onPaxChange(currentPax) {
    const { pax_min } = this.props.bookingInfo;
    this.setState({
      insufficientPax: currentPax < pax_min
    });
  }

  handleCodeChange(val) {
    this.setState({
      promoCode: val
    });
  }

  getPrice() {
    const { promoCode } = this.state;
    if (promoCode === '') {
      return;
    }
    const {
      fetchPricingInfo,
      bookingPax,
      match,
      bookingFormData,
      bookingInfo,
      byorSelected,
      bookingDate
    } = this.props;
    fetchPricingInfo(
      match.params.slug,
      bookingPax,
      promoCode,
      bookingFormData.email,
      bookingInfo.isByPax,
      byorSelected,
      bookingDate
    );
  }

  async initData() {
    const { slug, uuid } = this.props.match.params;

    const { fetchBookingInfo, fetchSavedInfo } = this.props;

    let totalPax = 0;
    if (this.props.bookingPax.adult){
      totalPax = this.props.bookingPax.adult + this.props.bookingPax.child;
    }
    else if (this.props.bookingPax > 0) {
      totalPax = this.props.bookingPax;
    }

    //If uuid is present in URL, try to fetch saved booking info
    if (uuid) {
      await fetchSavedInfo(uuid);
      const { tour_date_available, meeting_point_exist } = this.props.savedInfo;
      if (this.props.savedInfo) {
        if (!tour_date_available) {
          await fetchBookingInfo(slug, totalPax);
        } else if (!meeting_point_exist) {
          await fetchBookingInfo(slug, totalPax, this.props.savedInfo.tour_date);
        } else {
          await fetchBookingInfo(
            slug,
            totalPax,
            this.props.savedInfo.tour_date,
            this.props.savedInfo.meeting_point_id
          );
        }
      } else {
        await fetchBookingInfo(slug, totalPax);
      }
    } else {
      if (this.props.bookingDate !== '') {
        await fetchBookingInfo(slug, totalPax, this.props.bookingDate);
      } else {
        await fetchBookingInfo(slug, totalPax);
      }
    }

    const { error } = this.props;
    if (!error && this._isMounted) {
      const {
        bookingInfo,
        savedInfo,
        bookingDate,
        setBookingStep,
        setBookingPrimaryDriver,
        setBookingVehicle,
        setBookingAvailDates,
        setBookingDate,
        setBookingPax,
        setBookingPrice,
        setMeetingPoint,
        setDateWasReset,
        setBookingFormData,
        signedIn,
        user,
        userName,
        receiveErrorResponse,
        t
      } = this.props;

      // Set initial defaults
      let initialMeetingPoint = bookingInfo.meeting_points.find(
        mp => mp.selected
      );
      let initialVehicle;
      let recommendedVehicle = bookingInfo.vehicle_selection.find(
        vehicle => vehicle.is_recommended
      );
      if (recommendedVehicle && recommendedVehicle.is_available) {
        initialVehicle = recommendedVehicle;
      } else {
        initialVehicle = bookingInfo.vehicle_selection.find(
          vehicle => vehicle.is_available
        );
      }

      // If somehow meeting point or initial vehicle are both unavailable, OR if no available dates show custom error
      // if (
      //   !initialMeetingPoint ||
      //   !initialVehicle ||
      //   bookingInfo.booking_summary.available_dates.length < 1
      // ) {
      //   const errorObj = {
      //     response: {
      //       status: 403,
      //       data: {
      //         message: t('error:tripNotAvailable')
      //       }
      //     }
      //   };
      //   receiveErrorResponse(errorObj);
      //   return;
      // }

      // setMeetingPoint(initialMeetingPoint.id, initialMeetingPoint.name);
      // setBookingVehicle(initialVehicle.id, initialVehicle.title);
      // If user came from TripDetails page, skip setting initial pax and date. This part will probably be skipped regardless. Nvm no it wont
      if (bookingDate === '' || this.props.bookingPax === 0) {
        const availDates = bookingInfo.booking_summary.available_dates;
        const initialDate = availDates[0];
        const initialPax =
          bookingInfo.isByAge || bookingInfo.isByPax
            ?
            {
              adult: bookingInfo.pax_max,
              child: 0
            }
            : bookingInfo.pax_max;
        setBookingAvailDates(availDates);
        setBookingPax(initialPax);
        setBookingDate(initialDate);
      }
      setBookingStep(1);
      setBookingPrimaryDriver(true);

      // Prefill if user is signed in, but will override with saved info data
      if (signedIn) {
        setBookingFormData({
          name: userName,
          email: user.attributes.email,
          mobile: user.attributes['custom:phone_number']
            ? user.attributes['custom:phone_number'].slice(3)
            : ''
        });
      }

      // Check if its a saved booking and VALID (slug matches)
      if (savedInfo && savedInfo.slug === slug) {
        let savedBooking = savedInfo.data.booking;

        setBookingPax(savedBooking.pax_no);

        if (!savedInfo.meeting_point_exist && savedInfo.tour_date_available) {
          // If saved meeting point doesnt exist, show meeting point was reset error.
          // Only show MP reset error if tour date is available.
          setMeetingPoint(
            initialMeetingPoint.id,
            initialMeetingPoint.name,
            true
          );
        }
        // savedInfo.selected_vehicle_available is inaccurate, so do a frontend check if current vehicle ID exists
        const savedVehicleId = savedInfo.vehicle_id;
        const savedVehicle = bookingInfo.vehicle_selection.find(
          vehicle => vehicle.vehicle_id === savedVehicleId
        );
        if (savedVehicle && savedVehicle.is_available) {
          initialVehicle = savedVehicle;
          setBookingVehicle(initialVehicle.id, initialVehicle.title);
        } else if (!savedInfo.is_own_vehicle) {
          // If not available, set vehicle was reset to true
          setBookingVehicle(initialVehicle.id, initialVehicle.title, true);
        }
        // If saved date is not available, show error
        if (!savedInfo.tour_date_available) {
          setDateWasReset(true);
        }
        if (
          savedInfo.data.personal &&
          Object.keys(savedInfo.data.personal).length > 0
        ) {
          const personal = savedInfo.data.personal;
          setBookingFormData({
            name: personal.full_name || '',
            ic: personal.ic_no || '',
            email: personal.email || '',
            mobile: personal.mobile_no.slice(3) || '',
            size: personal.tshirt_size || ''
          });
          if (personal.is_driver) {
            setBookingPrimaryDriver(true);
          } else {
            setBookingPrimaryDriver(false);
          }
        }
        if (
          savedInfo.data.driver &&
          Object.keys(savedInfo.data.driver).length > 0
        ) {
          const driver = savedInfo.data.driver;
          setBookingFormData({
            driver_name: driver.full_name || '',
            driver_ic: driver.ic_no || '',
            driver_mobile: driver.mobile_no.slice(3) || '',
            driver_email: driver.email || '',
            driver_size: driver.tshirt_size || ''
          });
        }
      }

      const { bookingPax } = this.props;
      const simplePrice = calcSimplePrice(bookingInfo, bookingPax);
      setBookingPrice(simplePrice);
      this.setState({
        initData: true
      });
    }
  }

  render() {
    const { initData, showMobMenu, promoCode } = this.state;
    const {
      bookingInfo,
      bookingStep,
      error,
      paymentData,
      match,
      proceedToPayment,
      t
    } = this.props;
    const slug = match.params.slug;
    if (error) {
      return <ErrorDisplay error={error} />;
    }
    if (proceedToPayment) {
      // If paymentData returns a form object, proceed to iPay88
      if (paymentData && paymentData.form) {
        return (
          <>
            <LottieLoader />
            <HiddenForm formData={paymentData} />
          </>
        );
        // If it returns a redirect_url, trip is free, redirect to booking summary
      } else if (paymentData && paymentData.redirect_url) {
        return <Redirect to='/booking/summary' />;
      } else {
        return <LottieLoader />;
      }
    }
    if (!initData) {
      return <LottieLoader />;
    }
    return (
      <>
        <Helmet>
          <title>
            {t('gen:booking')} - {bookingInfo.booking_for} | {SITE_TITLE}
          </title>
        </Helmet>
        <div className='fe-booking-container'>
          <BookingMenu
            isMobile
            isLocked={bookingStep >= 2}
            isConfirmed={bookingStep === 3}
            isActive={showMobMenu}
            promoCode={promoCode}
            handleChange={this.handleCodeChange}
            handleClick={() => {
              this.setState({ showMobMenu: false });
            }}
          />
          <div className='container'>
            <h2 className='fe-booking-heading'>{t('form:bookingDetails')}</h2>
            <div className='fe-booking-tabs'>
              <div
                className={`fe-booking-tab ${bookingStep === 1 && 'active'}`}
              >
                {t('form:step1Text')}
              </div>
              <div
                className={`fe-booking-tab ${bookingStep === 2 && 'active'}`}
              >
                {t('form:step2Text')}
              </div>
              <div
                className={`fe-booking-tab ${bookingStep === 3 && 'active'}`}
              >
                {t('form:step3Text')}
              </div>
              <div className='fe-booking-tab'>{t('form:step4Text')}</div>
            </div>
          </div>

          <main className='fe-booking-main'>
            <div className='container'>
              <div className='row'>
                <BookingVehicleSelection
                  hide={bookingStep !== 1}
                  handleClick={() => {
                    this.props.history.push('/trips/' + window.location.pathname.substring(18) + '?back=true');
                  }}
                  handleSaveForLater={this.submitSaveForm}
                  disableNext={this.state.insufficientPax}
                />
                <BookingDetails
                  slug={slug}
                  promoCode={promoCode}
                  handleClick={() => {
                    this.setState({ showMobMenu: true });
                  }}
                  handleSaveForLater={this.submitSaveForm}
                  hide={bookingStep !== 2}
                />
                <BookingConfirmation
                  slug={slug}
                  hide={bookingStep !== 3}
                  promoCode={promoCode}
                  applyCode={this.getPrice}
                  handleChange={this.handleCodeChange}
                  promoPopupConfirm={val => {
                    this.setState({promoCode: val});
                    setTimeout(() => {
                      this.getPrice();
                    }, 500);}}
                />
                <div className='col-lg-4 position-relative'>
                  <BookingMenu
                    isLocked={bookingStep >= 2}
                    isConfirmed={bookingStep === 3}
                    promoCode={promoCode}
                    applyCode={this.getPrice}
                    handleChange={this.handleCodeChange}
                    onPaxChange={this.onPaxChange}
                  />
                </div>
              </div>
            </div>
          </main>
        </div>
      </>
    );
  }
}

Booking.propTypes = {
  match: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  bookingInfo: PropTypes.object.isRequired,
  savedInfo: PropTypes.object,
  bookingDate: PropTypes.string.isRequired,
  bookingPax: PropTypes.oneOfType([PropTypes.number, PropTypes.object])
    .isRequired,
  bookingVehicleId: PropTypes.number,
  bookingFormData: PropTypes.object.isRequired,
  bookingStep: PropTypes.number.isRequired,
  loading: PropTypes.bool.isRequired,
  paymentData: PropTypes.object.isRequired,
  primaryDriver: PropTypes.bool.isRequired,
  error: PropTypes.object,
  fetchBookingInfo: PropTypes.func.isRequired,
  setBookingAvailDates: PropTypes.func.isRequired,
  setBookingDate: PropTypes.func.isRequired,
  setBookingPax: PropTypes.func.isRequired,
  setBookingVehicle: PropTypes.func.isRequired,
  setBookingPrice: PropTypes.func.isRequired,
  setBookingStep: PropTypes.func.isRequired,
  setBookingPrimaryDriver: PropTypes.func.isRequired,
  setBookingFormData: PropTypes.func.isRequired,
  proceedToPayment: PropTypes.bool.isRequired,
  fetchPricingInfo: PropTypes.func.isRequired,
  clearPaymentData: PropTypes.func.isRequired,
  clearBookingFormData: PropTypes.func.isRequired,
  clearApiError: PropTypes.func.isRequired,
  setMeetingPoint: PropTypes.func.isRequired,
  toggleProceedToPayment: PropTypes.func.isRequired,
  fetchSavedInfo: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
  signedIn: PropTypes.bool.isRequired,
  user: PropTypes.object,
  bookingMeetingPointId: PropTypes.number,
  postSaveForLater: PropTypes.func.isRequired,
  updateSaveForLater: PropTypes.func.isRequired,
  saveUuid: PropTypes.string,
  receiveErrorResponse: PropTypes.func.isRequired,
  setDateWasReset: PropTypes.func.isRequired
};

const mapStateToProps = ({
  bookingState,
  apiState,
  authState,
  tripDetailsState
}) => ({
  bookingInfo: bookingState.bookingInfo,
  savedInfo: bookingState.savedInfo,
  bookingDate: bookingState.date,
  bookingPax: bookingState.pax,
  bookingPrice: bookingState.bookingPrice,
  bookingVehicleId: bookingState.selectedVehicleId,
  bookingMeetingPointId: bookingState.selectedMeetingPointId,
  bookingFormData: bookingState.formData,
  bookingStep: bookingState.step,
  primaryDriver: bookingState.primaryDriver,
  loading: bookingState.loading,
  paymentData: bookingState.paymentData,
  proceedToPayment: bookingState.proceedToPayment,
  user: authState.user,
  userName: authState.userName,
  signedIn: authState.signedIn,
  error: apiState.error,
  saveUuid: bookingState.saveUuid,
  byorSelected: tripDetailsState.byorSelected,
});

const mapDispatchToProps = {
  fetchBookingInfo,
  setBookingAvailDates,
  setBookingDate,
  setBookingPax,
  setBookingPrice,
  setBookingVehicle,
  setMeetingPoint,
  setBookingPrimaryDriver,
  setBookingStep,
  fetchPricingInfo,
  clearPaymentData,
  clearBookingFormData,
  clearApiError,
  toggleProceedToPayment,
  fetchSavedInfo,
  setBookingFormData,
  postSaveForLater,
  updateSaveForLater,
  receiveErrorResponse,
  setDateWasReset
};

export default withRouter(
  withTranslation()(
    connect(
      mapStateToProps,
      mapDispatchToProps
    )(Booking)
  )
);
